export enum Direction {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical",
  GRID = "grid"
}
